export default {
  ul: document.querySelector('.movies'),
  userInputField: document.querySelector(".input-search"),
  userSearchForm: document.querySelector(".search-form"),
  onInvalidSearch: document.querySelector("#invalid-search"),
  onNoResult: document.querySelector("#no-result"),
  inputContainer: document.querySelector(".header-bottom"),
  headerLibrary: document.querySelector('.header'),
  libraryBtn: document.querySelector('.go-lab'),
  homeBtn: document.querySelector('.go-home'),
  headerContainer: document.querySelector('.container'),
  mainSection: document.querySelector('main'),
  pagination: document.querySelector('.pagination'),
  mainSection: document.querySelector('.movies'),
  genresSelect: document.querySelector('#genresSelect'),
  addText: document.querySelector('.filter-lable-text'),
  addForm: document.querySelector('.form-row'),
  yearSelect: document.querySelector('#yearSelect'),
  langSwitch: document.querySelector('.theme-switch__toggle'),
  filterWrapper: document.querySelector('.filter-wrapper')
}
